import React from "react";
import Project from "./projet";

export function ProjectInPreparation() {
  return <Project status="En préparation" />;
}